import type { GetUserSearchPreferencesResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetUserSearchPreferencesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetUserSearchPreferencesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetUserSearchPreferencesArgs = Record<string, never>;

export const useGetUserSearchPreferences = createQueryHook<
  UseGetUserSearchPreferencesArgs,
  GetUserSearchPreferencesResponseRow[],
  GetUserSearchPreferencesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.userSearchPreferences.getUserSearchPreferences.queryOptions(),
  // Legacy query root is the `user_search_preferences` array (0..1 actor-pinned
  // rows); the tRPC procedure returns the unwrapped rows.
  mapTrpcDataToGraphQL: (data) => ({
    user_search_preferences: data,
  }),
  graphqlDocument: GetUserSearchPreferencesDocument,
  // The legacy consumer read via `useQuery(GetUserSearchPreferencesDocument, {})`
  // (Apollo's default `cache-first`), and the `upsertRecentUsers` /
  // `upsertUserSearchPreferences` mutations refresh it by evicting the
  // `user_search_preferences` cache field (see `useUpsertRecentUsers`). Keep
  // `cache-first` here so that eviction still forces a refetch — the
  // `createQueryHook` default of `no-cache` would bypass the cache and leave
  // stale recent users after a commit.
  graphqlFetchPolicy: 'cache-first',
});
